// plop_marker:layouts_import
import VoiceAgent11LabsEmbedded from "./voice-agent-11labs-embedded/index.js";
import ContactOptionsEmbedded from "./contact-options-embedded/index.js";
import BookAMeetingEmbedded from "./book-a-meeting-embedded/index.js";
import WhatsNewItemsListEmbedded from "./whats-new-items-list-embedded/index.js";
import MarkdownEmbedded from "./markdown-embedded/index.js";
import AmandaMeetingWizard from "./amanda-meeting-wizard/index.js";
export default {
    // plop_marker:layouts_add_layout
    ContactOptionsEmbedded,
    BookAMeetingEmbedded,
    WhatsNewItemsListEmbedded,
    MarkdownEmbedded,
    VoiceAgent11LabsEmbedded,
    AmandaMeetingWizard
};
